export function blobToFile(theBlob: any, fileName: any) {
	theBlob.lastModifiedDate = new Date();
	theBlob.name = fileName;
	return theBlob;
}

export default blobToFile;
